<template>
    <div class="blog-details-page">
        <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-brown" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        
        <div v-else-if="blog" class="blog-content">
            <!-- Hero / Header -->
            <div class="position-relative mb-5" style="height: 400px;">
                <img :src="blog.default_image.extra_large" class="w-100 h-100 object-fit-cover" :alt="blog.name">
                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
                <div class="position-absolute top-50 start-50 translate-middle text-center text-white w-75">
                    <h1 class="display-4 fw-bold font-serif mb-3">{{ blog.name }}</h1>
                    <p class="lead mb-0" v-if="blog.date">{{ blog.date }}</p>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <div class="bg-white p-4 p-md-5 rounded-4 shadow-sm" style="margin-top: -100px; position: relative; z-index: 2;">
                        <div class="content user-generated-content" v-html="blog.content"></div>
                        
                        <div class="mt-5 pt-4 border-top">
                            <a href="/" class="btn btn-outline-brown rounded-pill px-4">
                                <i class="bi bi-arrow-left me-2"></i> Back to Home
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="text-center py-5">
            <h3>Blog post not found</h3>
            <a href="/" class="btn btn-brown rounded-pill px-4 mt-3">Back to Home</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlogDetails',
    props: {
        blogId: {
            required: true
        }
    },
    data() {
        return {
            loading: true,
            blog: null
        }
    },
    async created() {
        await this.fetchBlog();
    },
    methods: {
        async fetchBlog() {
            try {
                // Assuming ArticleController::show maps to /api/articles/{id}
                const response = await axios.get(`/api/articles/${this.blogId}`);
                this.blog = response.data.data;
            } catch (error) {
                console.error("Error fetching blog:", error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.user-generated-content >>> img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 20px 0;
}
.user-generated-content >>> p {
    line-height: 1.8;
    color: #555;
    margin-bottom: 1.5rem;
}
</style>
